document.addEventListener('DOMContentLoaded', () => {
  document.querySelector('#menu-button').addEventListener('click', () => {
    document.documentElement.classList.toggle('main-menu--active');
  })
});

/* class remove mobile resize screen */
function removeClassIfWindowWidthIs960OrAbove() {
  const element = document.querySelector('html.js'); 
  const classNameToRemove = 'main-menu--active'; 
  if (window.innerWidth >= 979) {
    element.classList.remove(classNameToRemove);
  }
}
window.addEventListener('resize', removeClassIfWindowWidthIs960OrAbove);
removeClassIfWindowWidthIs960OrAbove();

/* header scrolling class add remove */
let scrollpos = window.scrollY;
let header = document.querySelector(".shopify-section-header");
function add_class_on_scroll() {
    header.classList.add("darkHeader");
}
function remove_class_on_scroll() {
    header.classList.remove("darkHeader");
}
window.addEventListener('scroll', function(){ 
    scrollpos = window.scrollY;
    if(scrollpos > 1){
        add_class_on_scroll();
    }
    else {
        remove_class_on_scroll();
    }
});


/* header hover 979 above class add remove */
function hoverfWindowWidthIs960OrAbove() {
  if (window.innerWidth >= 979) {
    const header_hover = document.querySelector(".shopify-section-header");

    header_hover.addEventListener("mouseenter", function() {
      header_hover.classList.add("darkHeader_hov");
    });
    
    header_hover.addEventListener("mouseleave", function() {
      header_hover.classList.remove("darkHeader_hov");
    });
  }
}
window.addEventListener('resize', hoverfWindowWidthIs960OrAbove);
hoverfWindowWidthIs960OrAbove();

/* header nav toggle menu mobile*/
document.addEventListener('DOMContentLoaded', function () {
  // Get all parent links with a submenu
  const parentLinks = document.querySelectorAll('.has-submenu');
  // Add click event listener to each parent link
  parentLinks.forEach(function (parentLink, index) {
    parentLink.addEventListener('click', function () {
       // Toggle the 'active' class to show/hide the submenu
      this.classList.toggle('mob-frst-act');
       // Hide other submenus when a new one is clicked
      parentLinks.forEach(function (otherLink, otherIndex) {
        if (otherLink !== parentLink && index !== otherIndex) {
          otherLink.classList.remove('mob-frst-act');
        }
      });
    });
    // Open the first submenu by default

    document.querySelector('#menu-button').addEventListener('click', () => {
      if (index === 0) {
        parentLink.classList.add('mob-frst-act');
      }
    });

    document.querySelector('#menu-button .close').addEventListener('click', () => {
        parentLink.classList.remove('mob-frst-act');
    });

  });
});

